import API from "../../../common/utils/API";
import MARVEL from "../../../common/utils/MarvelUrls";
import { setRouterLink } from "../../../router/RouterActions";
import {displayDuplicateMessage, displayErrorMessage} from "../../../common/marvel-reducers/formMessageActions";
import {closeAddEditModal} from "../../../veritas/add-edit/actions/AddEditActions";
import {
    setInputFieldsValueAction,
    updatedDPServiceRefresh,
    updateSvcConfigNamesArr
} from "../../../veritas/add-edit/actions/AddEditDPServiceActions";
import {activityLoggerActionTypes} from "../constants/UtilityMiddlewareConstants";
import {apiActionsDPService} from "../constants/ApiMiddlewareConstants";
import {
    fetchAllServices, fetchAllServicesSuccess, fetchKYBServices,
    fetchKYBServicesSuccess, fetchKYCServices,
    fetchKYCServicesSuccess, updateKYBFilters, updateKYCFilters
} from "../../../veritas/data-services/actions/ServicesActions";
import {fetchServiceDetailSuccess, toggleDeleteServiceWarning} from "../../../veritas/data-services/actions/ServiceDetailActions";
import {toUpperCaseSentence} from "../../../common/utils/ToUpperCaseSentence";
import INPUT_FIELDS from "../../../common/resources/inputfields.json";
import * as Validation from "../../../common/utils/Validation";

/**
 * This is the Middleware to handle the API calls pertaining to
 * Data Services. (Currently, only contains logic for post
 * and put... rest will be added subsequently.)
 * @param store, action
 * @returns Makes the API call and conditionally dispatches logger actions or
 * error or warning messages.
 */
const apiMiddlewareDPServices = (store) => (next) => (action) => {

    switch (action.type) {

        case apiActionsDPService.POST: {
            next(action);

            const { serviceObject, authToken } = action.payload;

            API.postDPService(serviceObject, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: res.data.service_id,
                        object_type: "dp_service_create",
                        user: authToken.account.name
                    }
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(closeAddEditModal("DP Service"))
                    store.dispatch(fetchAllServices())
                    store.dispatch(setRouterLink(MARVEL.VERITAS.kyc + res.data.service_id))

                }).catch(error => {
                    const message = [];
                    const errorObject = error.response.data
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [key, value] of Object.entries(errorObject)) {
                        const errorMessage = key + ": " + toUpperCaseSentence(value)
                        message.push(errorMessage);
                    }
                    if (errorObject['service_name']) {
                        store.dispatch(displayDuplicateMessage(message, true));
                    } else {
                        store.dispatch(displayErrorMessage(message, true));
                    }
                });
            break;
        }

        case apiActionsDPService.POST_KYB: {
            next(action);

            const { serviceObject, authToken } = action.payload;

            API.postKYBDPService(serviceObject, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: res.data.service_id,
                        object_type: "dp_service_create",
                        user: authToken.account.name
                    }
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(closeAddEditModal("DP Service"))
                    store.dispatch(fetchAllServices())
                    store.dispatch(setRouterLink(MARVEL.VERITAS.kyb + res.data.service_id))

                }).catch(error => {
                    const message = [];
                    const errorObject = error.response.data
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [key, value] of Object.entries(errorObject)) {
                        const errorMessage = key + ": " + toUpperCaseSentence(value)
                        message.push(errorMessage);
                    }
                    if (errorObject['service_name']) {
                        store.dispatch(displayDuplicateMessage(message, true));
                    } else {
                        store.dispatch(displayErrorMessage(message, true));
                    }
                });
            break;
        }

        case apiActionsDPService.PUT: {
            next(action);
            const { serviceID, reqObj, authToken } = action.payload;

            API.updateDPService(serviceID, reqObj, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: res.data.service_id,
                        object_type: "dp_service_edit",
                        user: authToken.account.name
                    }
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(closeAddEditModal("DP Service"));
                    // action to update the redux object holding all services.
                    store.dispatch(updatedDPServiceRefresh());
                }).catch(error => {
                    const message = [];
                    const errorObject = error.response.data
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [key, value] of Object.entries(errorObject)) {
                        const errorMessage = key + ": " + toUpperCaseSentence(value)
                        message.push(errorMessage);
                    }
                    if (errorObject['service_name']) {
                        store.dispatch(displayDuplicateMessage(message, true));
                    } else {
                        store.dispatch(displayErrorMessage(message, true));
                    }
                });
            break;
        }

        case apiActionsDPService.PUT_KYB: {
            next(action);
            const { serviceID, reqObj, authToken } = action.payload;

            API.updateKYBDPService(serviceID, reqObj, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: res.data.service_id,
                        object_type: "kyb_dp_service_edit",
                        user: authToken.account.name
                    }
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(closeAddEditModal("DP Service"));
                    // action to update the redux object holding all services.
                    store.dispatch(updatedDPServiceRefresh());
                }).catch(error => {
                    const message = [];
                    const errorObject = error.response.data
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [key, value] of Object.entries(errorObject)) {
                        const errorMessage = key + ": " + toUpperCaseSentence(value)
                        message.push(errorMessage);
                    }
                    if (errorObject['service_name']) {
                        store.dispatch(displayDuplicateMessage(message, true));
                    } else {
                        store.dispatch(displayErrorMessage(message, true));
                    }
                });
            break;
        }

        case apiActionsDPService.GET_ALL: {
            next(action);

            // commented until further changes.
            const { authToken } = action.payload;
            API.getAllDPServices(authToken.idToken)
                .then(res => {
                    store.dispatch(fetchAllServicesSuccess(res.data))
                }).catch(error => {
                    console.error(error);
                    throw error;
                });
            break;
        }

        case apiActionsDPService.GET_ALL_KYB: {
            next(action);

            const { authToken } = action.payload;
            API.getAllKYBServices(authToken.idToken)
                .then(res => {
                    store.dispatch(fetchKYBServicesSuccess(res.data));
                    // to apply any previously set filters to the fetched services
                    store.dispatch(updateKYBFilters());
                })
                .catch(error => {
                    console.error(error);
                    throw error;
                });
            break;
        }

        case apiActionsDPService.GET_ALL_KYC: {
            next(action);

            const { authToken } = action.payload;
            API.getAllKYCServices(authToken.idToken)
                .then(res => {
                    store.dispatch(fetchKYCServicesSuccess(res.data));
                    // to apply any previously set filters to the fetched services
                    store.dispatch(updateKYCFilters());
                })
                .catch(error => {
                    console.error(error);
                    throw error;
                });
            break;
        }

        case apiActionsDPService.GET: {
            next(action);

            const { serviceID, authToken } = action.payload;
            API.getDPServiceByID(serviceID, authToken.idToken)
                .then(responseServiceID => {
                    store.dispatch(fetchServiceDetailSuccess(responseServiceID.data, INPUT_FIELDS));
                })
                .catch(error => {
                    console.error(error);
                    throw error;
                });

            break;
        }

        case apiActionsDPService.GET_ONE_KYB: {
            next(action);

            const { serviceID, authToken } = action.payload;
            API.getKYBServiceByID(serviceID, authToken.idToken)
                .then(responseServiceID => {
                    store.dispatch(fetchServiceDetailSuccess(responseServiceID.data, INPUT_FIELDS));
                })
                .catch(error => {
                    console.error(error);
                    throw error;
                });


            break;
        }

        case apiActionsDPService.DELETE_KYC_SERVICE:{
            next(action);

            const {serviceID, authToken} = action.payload;
            API.deleteDPService(serviceID, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: serviceID,
                        object_type: "dp_service_delete",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(toggleDeleteServiceWarning());
                    // store.dispatch(fetchAllServices());
                    store.dispatch(fetchKYCServices());
                    store.dispatch(setRouterLink(MARVEL.VERITAS.kyc))
                })
                .catch()

            break;
        }

        case apiActionsDPService.DELETE_KYB_SERVICE:{
            next(action);

            const {serviceID, authToken} = action.payload;
            API.deleteKYBDPService(serviceID, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: serviceID,
                        object_type: "dp_service_delete",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(toggleDeleteServiceWarning());
                    // store.dispatch(fetchAllServices());
                    store.dispatch(fetchKYBServices());
                    store.dispatch(setRouterLink(MARVEL.VERITAS.kyb))
                })
                .catch()

            break;
        }

        case apiActionsDPService.CREATE_SERVICE_CONFIG_NAME: {
            next(action);

            const { scnObject, authToken } = action.payload;

            if (Validation.validateNewServiceConfigNameForm(scnObject)) {
                API.postServiceConfigName(scnObject, authToken)
                    .then(resSCN => {
                        const newService = resSCN.data.service;
                        store.dispatch(updateSvcConfigNamesArr([newService]));
                        API.getSupportingSelections(authToken)
                            .then(res => {
                                store.dispatch(setInputFieldsValueAction(res.data));
                            })
                    })
            }

            break;
        }

        case apiActionsDPService.COPY_SERVICE: {
            next(action);

            const { copyObject, authToken } = action.payload;
            API.copyServiceConfigName(copyObject, authToken)
                .then(resTransfer => {
                    store.dispatch(updatedDPServiceRefresh())
                })
                .catch(err => console.error(err))
            break;
        }

        default: next(action);

    }
}

export default apiMiddlewareDPServices;
